import { useQuery } from "@tanstack/react-query";
import publicApi from "@/lib/publicApi";

/**
 * Fetches a CMS page from the public API.
 * Caches per (slug, locale). 30s staleTime so admin edits propagate within ~30s.
 * `content` field has the editable map of section keys -> text/list/obj.
 */
export default function usePageContent(slug, locale) {
  return useQuery({
    queryKey: ["public-page", slug, locale],
    queryFn: async () => {
      const { data } = await publicApi.get(`/public/pages/${slug}`, { params: { locale } });
      return data;
    },
    enabled: Boolean(slug && locale),
    staleTime: 30_000,
  });
}

/**
 * Helper: get a string section. Falls back to empty string while loading.
 */
export function s(page, key, fallback = "") {
  if (!page || !page.content) return fallback;
  const v = page.content[key];
  if (v == null) return fallback;
  if (typeof v === "string") return v;
  return fallback;
}

/**
 * Helper: get list/array section (e.g. how_its_made steps, service services).
 */
export function list(page, key) {
  if (!page || !page.content) return [];
  const v = page.content[key];
  return Array.isArray(v) ? v : [];
}
